import * as angular from 'angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppStore } from '~/types/main.types';

import { AccountResource } from '@mode/legacy/data-access-model-js';
import { SpaceResource } from '@mode/legacy/data-access-model-js';
import { loggedInStateSelector } from '../../../reducers/selectors';
import { PlatformHeaderSelectors } from '../../../selectors/platform-header.selectors';

class ExploreHeaderController implements angular.IOnInit {
  isLoggedIn$: Observable<boolean>;
  account$: Observable<AccountResource>;
  accountContext$: Observable<AccountResource>;
  orgSpaces$: Observable<SpaceResource[]>;

  static $inject = ['AccountModel', 'OrgModel', 'SpaceModel', 'DataSourceModel', 'RxStoreService'];

  constructor(
    private accountMode: any,
    private orgModel: any,
    private spaceModel: any,
    private datasourceModel: any,
    private store: AppStore
  ) {}

  $onInit(): void {
    this.account$ = this.store.select(PlatformHeaderSelectors.SelectorFactories.account(this.accountMode));
    this.accountContext$ = this.store.select(
      PlatformHeaderSelectors.SelectorFactories.accountContext(this.accountMode)
    );
    this.isLoggedIn$ = this.store.select(loggedInStateSelector);

    this.orgSpaces$ = this.store
      .select(PlatformHeaderSelectors.SelectorFactories.orgSpaces(this.spaceModel))
      .pipe(map((models) => models && models.sort(this.spaceModel.navbarSort)));
  }
}

export const ID = 'reportViewExploreHeader';

export const reportViewExploreHeader: angular.IComponentOptions = {
  template: `
    <div class="explore-header">
      <nav-flyout ng-if="ctrl.isLoggedIn$ | async:this">
      </nav-flyout>
      <div class="header-details" ng-transclude="headerDetails"></div>
      <div class="header-cta" ng-transclude="headerCta"></div>
    </div>
  `,
  transclude: {
    headerDetails: 'headerDetailsSlot',
    headerCta: 'headerCtaSlot',
  },
  controller: ExploreHeaderController,
  controllerAs: 'ctrl',
  bindings: {
    theme: '<',
  },
};
